import { Modal, ModalBody, ModalContent, ModalProps } from "@heroui/react";
import { useState } from "react";
import SuggestionJobPositionSelectionStep from "./JobPositionSelectionStep";
import SuggestionConfirmStep from "./SuggestionConfirmStep";

export type SuggestionModalProps = Pick<ModalProps, "isOpen" | "onClose" | "onOpenChange"> & {
  jobSeekerId: string | null;
  setJobSeekerId: (jobSeekerId: string | null) => void;
};

const SuggestionModal: React.FC<SuggestionModalProps> = ({
  isOpen,
  onClose,
  onOpenChange,
  jobSeekerId,
  setJobSeekerId,
}) => {
  const [step, setStep] = useState<"confirmAssignment" | "jobPositionSelection">("jobPositionSelection");
  const [jobPositionId, setJobPositionId] = useState<string | null>(null);

  const handleStepChange = (step: "confirmAssignment" | "jobPositionSelection") => {
    setStep(step);
  };

  const handleClose = () => {
    setStep("jobPositionSelection");
    setJobPositionId(null);
    setJobSeekerId(null);

    onClose?.();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} onOpenChange={onOpenChange} className="max-w-[1300px]">
      <ModalContent className="p-4">
        <ModalBody className="flex items-center w-full gap-8">
          {step === "jobPositionSelection" && (
            <SuggestionJobPositionSelectionStep setJobPositionId={setJobPositionId} onStepChange={handleStepChange} />
          )}
          {step === "confirmAssignment" && (
            <SuggestionConfirmStep
              jobSeekerId={jobSeekerId}
              jobPositionId={jobPositionId}
              onStepChange={handleStepChange}
              onClose={handleClose}
            />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SuggestionModal;
